import {
  Component,
  Input,
  OnInit,
  OnChanges,
  AfterContentInit,
  AfterViewInit,
} from '@angular/core';
import { QuestionsService } from '../../services/questions.service';
import { Proposition, Question } from '../../interfaces/question.type';
import { ActivatedRoute } from '@angular/router';
import { core } from '@angular/compiler';
import { Quiz } from '../../interfaces/quiz.type';
import { CategoryQuizService } from '../../services/category-quiz.service';
import { CategoryQuestionService } from '../../services/category-question.service';
import { NiveauQuestionService } from '../../services/niveau-question.service';

@Component({
  selector: 'app-question-editor',
  templateUrl: './question-editor.component.html',
  styleUrls: ['./question-editor.component.scss'],
})
export class QuestionEditorComponent implements OnInit {
  @Input({ required: true }) question: Question;
  @Input({ required: true }) questionIndex!: number;

  allQuestions: any;
  editableLabel: boolean = false;
  correspondingQuiz: Quiz;
  editableTheme: boolean = false;
  initAnswerMode: Proposition;
  id: string;
  questionData: any;
  categoryList: any;
  levelList: any;
  currentLevel: any;
  hiddenLevel: boolean = true;

  constructor(
    private questions: QuestionsService,
    private router: ActivatedRoute,
    private category: CategoryQuestionService,
    private niveauQuestion: NiveauQuestionService
  ) {}

  ngOnInit(): void {
    this.id = this.router.snapshot.paramMap.get('id');
    let urlIdData = JSON.parse(this.router.snapshot.paramMap.get('data'));
    this.questionData = [urlIdData];
    console.log('Question courante: ', this.question);
    this.category.getAllQuestionCategories().subscribe({
      next: (data) => {
        this.categoryList = data;
        console.log('les categories disponible :', data);
      },
    });

    console.log('Page de modification....');

    this.currentLevel = this.question.niveauquestion.niveauquestionid;
    console.log('CuurentLevel choisit avec succés...', this.currentLevel);

    this.question.nbreReponse = this.question.proposition.filter(
      (reponse) => reponse.isCorrect === true
    ).length;

    if (this.question.proposition.length === 2) {
      this.question.typeReponse = 'Binaire';
    } else {
      this.question.typeReponse = 'Multiple';
    }

    this.niveauQuestion.getAllLevels().subscribe({
      next: (data) => {
        this.levelList = data.sort();
        console.log('niveau disponible :', data.sort());
      },
    });
  }

  specialCharacter(text: string) {
    return decodeURIComponent(encodeURIComponent(text));
  }

  toggleEditQuestionLabel() {
    this.editableLabel = !this.editableLabel;
  }

  // wantEditLevel(){
  //   this.hiddenLevel = false;
  //   this.currentLevel = this.levelList.filter((level)=>);
  //   console.log("il mouse over")
  // }

  toggleEditQuestionTheme() {
    this.editableTheme = !this.editableTheme;
  }

  descreaseDifficulty() {
    let b = this.findClosestDifficulty(
      this.levelList,
      this.currentLevel.pointdifficulte - 1
    );
    console.log(b);
  }

  changeQuestionLevel(level: any) {
    this.currentLevel = level;
    // this.currentLevel = ;
    this.question.niveauquestion = this.levelList.filter(
      (levelEl: any) => levelEl.niveauquestionid === level
    )[0];
    console.log('le current level state: ', this.currentLevel, this.question);
  }

  findClosestDifficulty(allLevels: any[], target: number): number {
    let numbers = allLevels.map((niveau) => niveau.pointdifficulte);
    let closestNumber = numbers[0];
    let closestDistance = Math.abs(numbers[0] - target);

    for (let i = 1; i < numbers.length; i++) {
      const distance = Math.abs(numbers[i] - target);
      if (distance < closestDistance) {
        closestNumber = numbers[i];
        closestDistance = distance;
      }
    }
    console.log(closestNumber);

    this.currentLevel = allLevels.filter(
      (level) => level.pointdifficulte === closestNumber
    )[0];
    this.question.niveauquestion = this.currentLevel;
    console.log(this.currentLevel);
    return closestNumber;
  }

  increaseDifficulty() {
    // if (this.question.difficulte < 3) {
    //   this.question.difficulte += 1;
    //   console.log('Upm difficulty : ', this.question);
    // }
    let b = this.findClosestDifficulty(
      this.levelList,
      this.currentLevel.pointdifficulte + 1
    );

    console.log(b);
  }

  difficultyStatus(id: number): string {
    let status: string;
    switch (id) {
      case 1:
        status = 'Facile';
        break;
      case 2:
        status = 'Moyen';
        break;
      case 3:
        status = 'Difficile';
        break;

      default:
        break;
    }

    return status;
  }

  toggleAnswerMode($event: any) {
    try {
      console.log('Mode actuel : ', $event);
      if ($event == 'Binaire') {
        this.question.proposition = [
          {
            title: 'Vrai',
            isCorrect: true,
            code: null,
          },
          {
            title: 'Faux',
            isCorrect: false,
            code: null,
          },
        ];
        console.log('deux champs', $event);
      } else {
        console.log('4 champs', $event);
        this.question.proposition = [
          {
            title: '',
            isCorrect: true,
            code: null,
          },
          {
            title: '',
            isCorrect: false,
            code: null,
          },
          {
            title: '',
            isCorrect: false,
            code: null,
          },
          {
            title: '',
            isCorrect: false,
            code: null,
          },
        ];
      }
    } catch (error) {
      console.log(error, $event);
    }
  }

  onCategoryChange($value: any) {
    console.log('Selected category:', $value);
    this.question.categoriequestion = $value;
  }

  selectCorrectAnswer(
    proposition: Proposition,
    clickedPropositionIndex: number
  ) {
    console.log('Proposition : ', this.question);

    const propositionIndex = this.question.proposition.indexOf(proposition);

    if (this.question.typeReponse === 'Multiple') {
      if (propositionIndex !== -1) {
        this.question.proposition[propositionIndex] = {
          ...proposition,
          isCorrect: !proposition.isCorrect,
        };
      }
    } else {
      console.log('Le type de reponse est binaire');
      this.question.proposition = this.question.proposition.map(
        (proposition, index) => {
          if (index === clickedPropositionIndex) {
            // Si la proposition cliquée est déjà marquée comme correcte,
            // on la marque comme fausse, et vice versa.
            return {
              ...proposition,
              isCorrect: !proposition.isCorrect,
            };
          } else {
            // Si une autre proposition est marquée comme correcte,
            // on la marque comme fausse.
            return {
              ...proposition,
              isCorrect: false,
            };
          }
        }
      );

      console.log(
        'Hello',
        this.question.proposition.map((proposition, index) => {
          if (proposition.isCorrect) {
            return {
              ...proposition,
              isCorrect: false,
            };
          } else {
            return {
              ...proposition,
              isCorrect: true,
            };
          }
        })
      );
    }

    this.question.nbreReponse = this.question.proposition.filter(
      (reponse) => reponse.isCorrect === true
    ).length;
  }
}
